/**
 * Ctrl K / ⌘K: the physical K key on any keyboard layout. With the Persian layout `key` is «ن»,
 * so only `code` matches, and without our preventDefault the browser opens its own web search.
 */
export function isPaletteShortcut(e: Pick<KeyboardEvent, 'ctrlKey' | 'metaKey' | 'altKey' | 'code' | 'key'>): boolean {
  return (e.ctrlKey || e.metaKey) && !e.altKey && (e.code === 'KeyK' || e.key.toLowerCase() === 'k');
}

/** Opens the palette on Ctrl K / ⌘K from anywhere inside an organization (call while initializing). */
export function paletteShortcut(toggle: () => void): void {
  $effect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (isPaletteShortcut(e)) {
        e.preventDefault();
        toggle();
      }
    };
    // Capture: a field that stops the event cannot let the browser shortcut through.
    window.addEventListener('keydown', onKey, { capture: true });
    return () => window.removeEventListener('keydown', onKey, { capture: true });
  });
}
